const colors = {
  black: "#000000",
  white: "#fff",
  blue: "rgb(29,161,242)",
  lightBlue: "rgb(230, 236, 240)"
};

export default colors;
